module.exports = function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/stringhelpers/to-title-case.js
 **/